import { CHECKLIST_STEP_STATUS_COMPLETED, CHECKLIST_STEP_STATUS_IN_PROGRESS } from '@/lib/threadChecklist.js';

// How far through the active checklist the thread is. `currentPosition` is the step being worked on: the
// in-progress item when there is one, else the first one not yet done — a checklist the model has not
// advanced still has a front, and it is the step after the last one it finished.
const buildChecklistProgress = (checklist) => {
  if (!Array.isArray(checklist) || checklist.length < 1) {
    return null;
  }

  const total = checklist.length;
  const completedCount = checklist.filter((item) => item?.status === CHECKLIST_STEP_STATUS_COMPLETED).length;
  const inProgressIndex = checklist.findIndex((item) => item?.status === CHECKLIST_STEP_STATUS_IN_PROGRESS);
  const currentPosition = inProgressIndex >= 0 ? inProgressIndex + 1 : Math.min(completedCount + 1, total);

  return { total, currentPosition };
};

export default buildChecklistProgress;
